import React, { useContext, useState } from "react";
import "../../../assets/styles/component/cedarShell.scss";
import { PopUpMessagesContext } from "../../../context";
import { usePageViewTracking } from "../../../hooks";
import { postDataV2 } from "../../../api/utils";
import { ReleaseNotes } from "../../Modals/messages";
import { CedarShellHeader } from "./CedarShellHeader";
import { CedarShellSidenav } from "./CedarShellSidenav";
import { CedarShellSidenavContext } from "./CedarShellSidenavContext";

interface Props {
  children: JSX.Element;
}

// Self-contained alternative to DashboardLayout for the new Home-only shell (header + collapsible
// sidenav + content), rather than adding a "hide the old nav" escape hatch to DashboardLayout
// itself - that component is shared by ~40+ existing dashboard pages and its .dashboard grid CSS
// reserves a column for the old DashboardMenu, so suppressing just the menu there would leave a
// blank gutter. This still preserves the cross-cutting behaviors DashboardLayout provides
// (page-view tracking, the release notes popup) without depending on that shared grid. The forced
// first-login department prompt (SelectDepartmentForm) that used to render here was removed - a
// user's department is always editable from Settings' own DepartmentInput field regardless.
export const CedarShellLayout = (props: Props) => {
  const { children } = props;

  const { releaseNote, setShowReleaseMessage, showReleaseMessage } = useContext(PopUpMessagesContext);
  // Expanded by default - DashboardCard/ArchivedDashboardCard/AlertCard already call setCollapsed(true)
  // right before navigating to a dashboard, so it only collapses once the user actually leaves Home.
  const [collapsed, setCollapsed] = useState(false);

  usePageViewTracking();

  const handleReleaseNotesClose = () => {
    setShowReleaseMessage(false);
    postDataV2(`/user-messages/mark-release-note-seen?id=${releaseNote?.id}`, {});
  };

  return (
    <CedarShellSidenavContext.Provider value={{ collapsed, setCollapsed }}>
      <div className="cedar_shell" data-test-id="cedar-shell">
        <CedarShellHeader />
        <div className="cedar_shell_body">
          <CedarShellSidenav />
          <main className="cedar_shell_content">{children}</main>
        </div>
        <ReleaseNotes
          isVisible={showReleaseMessage}
          onCloseClick={handleReleaseNotesClose}
          notes={releaseNote?.popup_note ? releaseNote?.popup_note : ""}
        />
      </div>
    </CedarShellSidenavContext.Provider>
  );
};
